module.exports = __webpack_public_path__ + "static/Michal_2_min-5ba5d88ff1f4e72db425747393a977c5.jpg";